import React, { useEffect, useState } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest } from '../../services/httpService';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import helpers from '../../services/helpers';
import { Link } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
 
export default function PaymentsListModal ({
        show_modal, 
        close_modal, 
        handleSelect, 
        id,
        src=""
    }){
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [data_list, setDataList] = useState([]);
    const [table_data, setTableData] = useState([]);
    const [label, setLabel] = useState('Customer Payments');
   
    useEffect(() => {
        if(show_modal && id) {
            fetchData()
        }

        if(src === 'made'){
            setLabel('Vendor Payments')
        }
    }, [show_modal]);
   
    useEffect(() => {
        setTableData(
            <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', minHeight: '0' }}>
            <DataTable 
                className=''
                value={data_list} 
                size="normal"
                scrollHeight="flex"
                responsive={true}
                loading={loading}
                scrollable
                emptyMessage="No data to display"
            >
                <Column field="payment_date" header="DATE" ></Column>
                {/* {
                    src === 'made' ?
                    <Column field="payment_no" header="PAYMENT NO" body={({payment_made_id, payment_no})=> <Link to={`/payment-made/${payment_made_id}/edit`}>{payment_no}</Link>}></Column> : 
                    <Column field="payment_no" header="PAYMENT NO" body={({payment_received_id, payment_no})=> <Link to={`/payment-receives/${payment_received_id}/edit`}>{payment_no}</Link>}></Column>
                } */}
                {
                    src === 'made' ?
                    <Column field="payment_no" header="PAYMENT NO" body={({payment_made_id, payment_no})=> payment_no}></Column> : 
                    <Column field="payment_no" header="PAYMENT NO" body={({payment_received_id, payment_no})=> payment_no}></Column>
                }
                <Column field="payment" header="AMOUNT" body={({payment})=> payment ? helpers.formatCurrencyAmount(payment) : '---' }></Column>
                <Column field="payment_method" header="METHOD" ></Column>
                <Column field="reference_no" header="REFERENCE NO" body={({reference_no})=> reference_no ? reference_no : '---' }></Column>
                <Column field="notes" header="NOTES" body={({ notes }) => <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={notes}>{notes || '---'}</div>} style={{ maxWidth: '200px' }}></Column>
                {
                    src === 'made' ?
                    <Column 
                        header="ACTION" 
                        body={({payment_made_id})=> (
                            <Link to={`/payment-made/${payment_made_id}/edit`} className='btn btn-sm btn-outline-primary'>
                                <i className="fas fa-edit"></i> Edit
                            </Link>
                        )}
                    ></Column> : 
                    <Column 
                        header="ACTION" 
                        body={({payment_received_id})=> (
                            <Link to={`/payment-receives/${payment_received_id}/edit`} className='btn btn-sm btn-outline-primary'>
                                <i className="fas fa-edit"></i> Edit
                            </Link>
                        )}
                    ></Column>
                }
            </DataTable>
            </div>
        )
    }, [data_list]);

    function handleClose(e) {
        reset();
        close_modal(0);
    }

    function onSelect(e){
        reset();
        close_modal(0);
        handleSelect(e)
    }

    function fetchData(search = '') {
        setLoading(1)

        let filter = '?store_id='+helpers.getStoreID()+'&pagination=0&with_default=1&'

        if(search){
            filter += 'search='+search+'&'
        }

        filter = filter.slice(0, -1)

        let url = helpers.createUrl(`V1/manage/invoices/${id}/payments${filter}`)

        if(src === 'made'){
            url = helpers.createUrl(`V1/manage/bills/${id}/payments${filter}`)
        }

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setNotice('')
                setDataList(res)
                setLoading(0)
            })
            .catch((err) => {
                reset()
                setLoading(0)
                setNotice(<div className="alert alert-danger mt-3 px-3 py-2 mb-0" role="alert">Unable to fetch data.</div>)
            }); 
    }

    function reset(){
        setDataList([])
        setTableData([])
        setNotice('')
    }

    return (
        <>
            <Modal show={show_modal} size='xl'>
                <Modal.Header className='d-flex align-items-center'>
                    <h5 className='mb-0'>{label}</h5>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body className='px-0 pt-0' style={{ height: '75vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <div>
                    {table_data}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}